/** Return only a local application route, never another origin or an authentication loop. */
export function authReturnPath(value: unknown): string {
  if (
    typeof value !== 'string' ||
    !value.startsWith('/') ||
    value.startsWith('//') ||
    [...value].some(
      (character) =>
        character === '\\' || character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127,
    )
  )
    return '/';
  try {
    const path = new URL(value, 'https://return.invalid');
    if (
      path.origin !== 'https://return.invalid' ||
      ['/sign-in', '/sign-up', '/auth/callback'].includes(path.pathname.replace(/\/+$/, ''))
    )
      return '/';
    return `${path.pathname}${path.search}${path.hash}`;
  } catch {
    return '/';
  }
}
